import { graphql, useStaticQuery } from 'gatsby';

/**
 * Получаю список компаний
 * @param callback
 * @returns {*}
 */
export default ({ children, options: { id, title } = {} }) => {
  let data = useStaticQuery(graphql`
    query {
      allCompanyJson(limit: 9999) {
        edges {
          node {
            fields {
              uri
              id
            }
            title
            link
            rating {
              creative {
                creative
                values {
                  knowledge
                  partnership
                  quality
                }
              }
              smm {
                smm
                values {
                  knowledge
                  partnership
                  quality
                }
              }
              native {
                native
                values {
                  knowledge
                  partnership
                  quality
                }
              }
              influence {
                influence
                values {
                  knowledge
                  partnership
                  quality
                }
              }
              web {
                web
                values {
                  knowledge
                  partnership
                  quality
                }
              }
              mobile {
                mobile
                values {
                  knowledge
                  partnership
                  quality
                }
              }
              video {
                video
                values {
                  knowledge
                  partnership
                  quality
                }
              }
              banners {
                banners
                values {
                  knowledge
                  partnership
                  quality
                }
              }
              videoads {
                videoads
                values {
                  knowledge
                  partnership
                  quality
                }
              }
              context {
                context
                values {
                  knowledge
                  partnership
                  quality
                }
              }
              seo {
                seo
                values {
                  knowledge
                  partnership
                  quality
                }
              }
              lead {
                lead
                values {
                  knowledge
                  partnership
                  quality
                }
              }
              cpi {
                cpi
                values {
                  knowledge
                  partnership
                  quality
                }
              }
            }
          }
        }
      }
    }
  `);

  data = data.allCompanyJson.edges.map(({ node }) => ({
    title: node.title,
    uri: node.fields.uri,
    id: node.fields.id,
    rating: node.rating,
    link: node.link
  }));

  if (title) {
    const TitleRegExp = new RegExp('^' + title, 'i');
    data = data.filter(item => TitleRegExp.test(item.title));
    data
        .sort((a, b) => {
          if (a.title > b.title) {
            return -1;
          }
          if (b.title > a.title) {
            return 1;
          }
          return 0;
        })
        .reverse();
  }

  if (id) {
    data = data.filter(item => item.id === id);
    if (data.length > 0) {
      data = data[0];
    } else {
      data = null;
    }
  }

  return children(data);
};
